/*
 * Copyright (c) 2023. Haodong JU
 */

import IKDataEntity from '@/plugins/EntityFrameWork/IKDataEntity'
import hillo from 'hillo'

const entity = {
  id: {
    type: IKDataEntity.Types.Integer,
    displayName: 'id'
  },
  createdAt: {},
  totalPrice: {},
  checkDetail: {
    displayName: 'detail',
    type: IKDataEntity.Types.Integer,
    form: false,
    tableConfig: {
      overwrite: true
    }
  }
}
const config = {
  load: async function (filter) {
    return (await hillo.get('https://cloud-minus.aaden.io/orders/last100By/' + filter[0].dataTerminalId)).map(it => {
      it.detailInfo = JSON.parse(it.content)
      return it
    })
  }
}
export default IKDataEntity.ModelFactory(entity, config)
